import Module from './Module_v2';

export default Module;
